// extracted by mini-css-extract-plugin
module.exports = {"myListButton":"pQ","bigIcon":"pR","iconOnHoverStyle":"pS","iconOnHoverRentalStyle":"pT","inOnboardingRecommendation":"pU"};